import React, { useEffect } from "react";

const CookieYes = () => {

    useEffect(() => {
        const script = document.createElement('script');

        script.id = "cookieyes"
        script.type = "text/javascript"
        script.src = "https://cdn-cookieyes.com/client_data/eb5eae3f7ff855dd3e755fbf0693025b/script.js"

        document.head.appendChild(script);

    }, [])

    return (
        <></>
    )
}

export default CookieYes
